import { createSlice } from "@reduxjs/toolkit";
import { HandWashProduct } from "../../Api/Api"; // Import API function

const handWashSlice = createSlice({
    name: "handWash",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(HandWashProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(HandWashProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(HandWashProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default handWashSlice.reducer;
